import { ActionsStripDto } from '../maintenance/action/ActionsStripDto';
import { AccessControlPhaseTransitionDto } from './AccessControlPhaseTransitionDto';

export class AccessControlPhaseTransitionsDto {
  public phaseId: number = 0;
  public accessControlId: number = 0;
  public transitions: AccessControlPhaseTransitionDto[] = [];
  public actions: ActionsStripDto | null = null;

  public static build(value: AccessControlPhaseTransitionsDto): AccessControlPhaseTransitionsDto | null {
    if (value == null)
      return null;
    const dto = new AccessControlPhaseTransitionsDto();
    dto.phaseId = value.phaseId;
    dto.transitions = value.transitions ?? [];
    if (value.actions != null)
      dto.actions = ActionsStripDto.buildFromActionsStripDto(value.actions);
    return dto;
  }
}
